import React, { useRef, useState } from "react"
import { Input, Progress, FormFeedback } from "reactstrap"
import "flatpickr/dist/themes/material_blue.css"
import toast from "react-hot-toast"
import { APICore } from "helpers/api/apiCore"
import { useLogout } from "hooks/useLogout"
import UploadFile from "../../assets/images/icons/upload-file.svg"

const api = new APICore()

const VideoUploader = ({
  value = null,
  fieldKey,
  validation,
  extensionAllowedInput = ".mp4,.mov,.avi,.webm",
  extensionAllowed = [
    "video/mp4",
    "video/quicktime", // .mov
    "video/x-msvideo", // .avi
    "video/webm",
  ],
  placeholder = "Upload your video here",
  typeError = "Please upload files in MP4, MOV, AVI, or WEBM format only.",
  maxSizeMB = 50,
}) => {
  const [file, setFile] = useState(value)
  const [progress, setProgress] = useState(0)
  const fileRef = useRef(null)
  const logout = useLogout()

  const truncateString = (str, maxLength = 35) => {
    if (str.length <= maxLength) return str
    return str.slice(0, maxLength) + "..."
  }

  const onUploadFile = async (file) => {
    try {
      if (!file) {
        toast.error("Please select a file.", { id: "toasterMessage" })
        return
      }

      if (!extensionAllowed.includes(file.type)) {
        toast.error(typeError, { id: "toasterMessage" })
        return
      }

      const maxSize = maxSizeMB * 1024 * 1024
      if (file.size > maxSize) {
        toast.error(`You can upload a maximum ${maxSizeMB}MB video`, {
          id: "toasterMessage",
        })
        return
      }

      const { data } = await api.uploadFile(
        "/common/file",
        { file },
        (progressEvent) => {
          const progress = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
          setProgress(progress)
        }
      )
      validation.setFieldValue(fieldKey, data.data.filename)
    } catch (error) {
      if (error.status === 401) {
        logout()
      }
      toast.error(error?.response?.data?.message || "Upload failed", {
        id: "toasterMessage",
      })
    }
  }

  return (
    <>
      <div
        className={`input-wrapper ${
          validation.errors[fieldKey] ? "is-invalid" : ""
        }`}
        onClick={() => fileRef?.current?.click()}
      >
        <Input
          name={fieldKey}
          type="file"
          innerRef={fileRef}
          className="form-control d-none"
          placeholder={placeholder}
          accept={extensionAllowedInput}
          onChange={(e) => {
            const file = e.target.files[0]
            if (file) {
              onUploadFile(file)
              setFile(file)
            }
          }}
        />

        <Input
          type="text"
          className="form-control"
          value={file ? truncateString(file?.name || file) : placeholder}
          readOnly
        />
        <img src={UploadFile} alt="upload" />
      </div>

      {validation.errors[fieldKey] && (
        <FormFeedback type="invalid">
          {validation.errors[fieldKey]}
        </FormFeedback>
      )}

      {progress > 0 && progress < 100 && (
        <Progress
          className="w-100"
          value={progress}
          style={{ height: "3px" }}
        />
      )}
    </>
  )
}

export default VideoUploader
